const _ = require('lodash')
class Transform {
  constructor(json, tabs = []) {
    this.json = json
    this.tabs = tabs
  }

  transformComponent() {
    if (!this.json.ui) return
    if (!this.json.ui.drawflow) return

    const drawflow = this.json.ui.drawflow

    const output = { start: -1, components: {} }
    for (const page in drawflow) {
      const components = drawflow[page].data

      for (const node in components) {
        const { data, outputs } = components[node]

        const item = {
          type: data.node,
          name: data.name
        }

        if (data.property && !['condition'].includes(data.node)) {
          item.property = data.property
        }

        let out = []
        if (Object.entries(outputs).length === 1) {
          out = [
            {
              id: outputs.output_1.connections[0].node
            }
          ]

          item.goto = out
        } else if (Object.entries(outputs).length > 1) {
          let i = 0
          for (const [key, value] of Object.entries(outputs)) {
            if (value && value.connections.length > 0) {
              if (['condition'].includes(data.node)) {
                if (data.property.conditions && data.property.conditions[i]) {
                  out.push({
                    condition: data.property.conditions[i].condition,
                    id: value.connections[0].node
                  })
                }
                i++
              } else if (['input', 'chat_input'].includes(data.node)) {
                out.push({
                  utterance_type: key === 'output_1' ? 'default' : 'no_input',
                  id: value.connections[0].node
                })
              } else if (['api'].includes(data.node)) {
                out.push({
                  is_success: key === 'output_1' ? true : false,
                  id: value.connections[0].node
                })
              } else {
                out.push({
                  condition: key === 'output_1' ? true : false,
                  id: value.connections[0].node
                })
              }
            }
          }

          item.goto = out
        }

        if (['start', 'chat_start'].includes(data.node)) {
          output.start = node
        }

        if (['page'].includes(data.node)) {
          // const subPage = data.property.page
          // const startPage = this.findPageStart(drawflow[subPage])

          if (!data.property.is_custom_component)
            item.step_into = { id: data.property.page }
          else item.step_into = { id: data.property.component }
        }

        if (['loop', 'chat_start'].includes(data.node)) {
          item.step_into = { id: data.property.page }
        }
        output.components[node] = item
      }
    }

    output.components = this.transformPostback(output.components)
    return output
  }

  transformPostback(components) {
    for (const iterator of Object.keys(components)) {
      const { type, property } = components[iterator]
      if (type === 'chat_output') {
        const { bot_says } = property
        for (const bot_say of bot_says) {
          const { type, payload, payloads, isManual } = bot_say
          if (type === 'button') {
            for (const pay of payload.buttons) {
              const { payload: payloadButtonPay, type: typeButtonPay } = pay
              if (typeButtonPay === 'postback') {
                pay.payload = `${payloadButtonPay}!@@${iterator}`
              }
            }
          }
          if (type === 'carousel' && isManual) {
            for (const pay of payloads) {
              const { buttons } = pay
              for (const button of buttons) {
                const { payload: payloadButton, type: typeButton } = button
                if (typeButton === 'postback') {
                  button.payload = `${payloadButton}!@@${iterator}`
                }
              }
            }
          }
        }
      }
    }
    return components
  }

  validateBeforeSave(draw) {
    for (const page in draw.drawflow) {
      const data = draw.drawflow[page].data

      for (const [key, node] of Object.entries(data)) {
        const errorInputOutput = this.validateInputOutput(node)
        if (errorInputOutput)
          return {
            is_valid: false,
            page,
            id: node.id,
            message: errorInputOutput
          }

        const errorData = this.validateData(node.data)
        if (errorData)
          return {
            is_valid: false,
            open_panel: true,
            page,
            id: node.id,
            message: errorData
          }
      }
    }

    return { is_valid: true }
  }

  validateInputOutput(node) {
    // check input
    if (Object.keys(node.inputs).length > 0) {
      for (const input in node.inputs) {
        if (node.inputs[input].connections.length === 0) {
          return `Component ${node.name} - input is required`
        }
      }
    }

    // check output
    if (Object.keys(node.outputs).length > 0) {
      for (const output in node.outputs) {
        if (node.outputs[output].connections.length === 0)
          return `Component ${node.name} - output is required`
      }
    }

    return
  }

  validateVariableFormat(text, allowType = 'single') {
    let is_valid = false

    if (text) {
      const backet = text.match(/\${(.*?\s*\})/g)
      const valueInBacket = (backet || []).map(val =>
        val.replace(/\${/g, '').replace(/}/g, '')
      )
      const backetLength = (backet || []).length
      const openSymbolBacketLength = (text.match(/\${/g) || []).length
      const symbolLength = (text.match(/\$/g) || []).length
      const openBacketLength = (text.match(/{/g) || []).length
      const closeBacketLength = (text.match(/}/g) || []).length

      if (
        allowType === 'single' &&
        backetLength === 1 &&
        valueInBacket.filter(val => val === '').length === 0 &&
        [
          backetLength,
          openSymbolBacketLength,
          symbolLength,
          openBacketLength,
          closeBacketLength
        ].every((val, i, arr) => val === arr[0]) &&
        text.slice(0, 2) === '${' &&
        text.slice(-1) === '}'
      ) {
        is_valid = true
      } else if (
        allowType === 'multiple' &&
        backetLength > 0 &&
        valueInBacket.filter(val => val === '').length === 0 &&
        [
          backetLength,
          openSymbolBacketLength,
          symbolLength,
          openBacketLength,
          closeBacketLength
        ].every((val, i, arr) => val === arr[0])
      ) {
        is_valid = true
      }
    }

    return is_valid
  }

  validateData(nodeData) {
    const data = JSON.parse(JSON.stringify(nodeData))

    if (!data.name) return 'Name is required'

    // common
    if (data.node === 'add_retry') {
      // type === 'page'
      if (data.property.type === 'page') {
        if (!data.property.page) return 'Page is required'

        const findPage = _.find(this.tabs, { id: data.property.page })
        if (!findPage) {
          return 'Page is required'
        }
      }
      // type === 'page_name'
      else if (data.property.type === 'component') {
        if (!data.property.component) return 'Component is required'
      }
    }
    if (data.node === 'api') {
      if (!data.property.url) return 'URL is required'

      for (const obj of data.property.headers) {
        if (!obj.key) return 'Key is required'
      }
    }
    if (data.node === 'code') {
      try {
        const resultText = this.replaceParametes({
          rawText: data.property.code,
          replaceValue: '0'
        })

        new Function(resultText)()
      } catch (err) {
        return err
      }
    }
    if (data.node === 'condition') {
      for (const obj of data.property.conditions) {
        if (!obj.condition) return 'Condition is required'
      }
    }
    if (data.node === 'intent_mapping') {
      if (!data.property.intent_variable) return 'Intent variable is required'
      else if (!this.validateVariableFormat(data.property.intent_variable))
        return 'Variable must be in ${*} format'

      for (const obj of data.property.mapping) {
        if (!obj.page) return 'Page is required'
      }
    }
    if (data.node === 'jump') {
      if (data.property.type === 'component') {
        if (!data.property.component) return 'Component is required'
      }
    }
    if (data.node === 'page') {
      if (!data.property.type) data.property.type = 'page'

      // type === 'page'
      if (data.property.type === 'page') {
        if (!data.property.page) return 'Page is required'
        else if (data.property.is_custom_component && !data.property.component)
          return 'Component is required'

        const findPage = _.find(this.tabs, { id: data.property.page })
        if (!findPage) {
          return 'Page is required'
        }
      }
      // type === 'page_name'
      else {
        if (!data.property.page_name) return 'Page name is required'
      }
    }
    if (data.node === 'loop') {
      if (!data.property.variable) return 'Array variable is required'
      else if (!this.validateVariableFormat(data.property.variable))
        return 'Variable must be in ${*} format'

      if (data.property.page === '') return 'Page is required'
    }
    if (data.node === 'write') {
      if (data.property.operation === 'clear') {
        if (
          !data.property.fields ||
          (data.property.fields && data.property.fields.length === 0)
        )
          return 'Select at least 1 field'

        data.field_id = null
      } else {
        if (!data.property.field_id) return 'Field is required'

        if (data.property.operation === 'lookup') {
          if (data.property.searching_key === '')
            return 'Search key is required'

          if (
            data.property.lookup_table_id == undefined ||
            data.property.lookup_table_id === ''
          ) {
            return 'Lookup table is required'
          }

          if (data.property.column_index === '')
            return 'Column index is required'
        } else {
          if (data.property.value === '') return 'Value is required'
        }

        data.fields = null
      }
    }
    if (data.node === 'mail') {
      if (!data.property.to || data.property.to == '')
        return 'To field is required'

      if (!data.property.subject || data.property.subject == '')
        return 'Subject is required'

      if (!data.property.body || data.property.body == '') {
        return 'Mail content is required'
      }
    }
    if (data.node === 'schedule') {
      if (!data.property.schedule) return 'Schedule is required'
    }

    // voice
    if (data.node === 'prompt') {
      for (const obj of data.property.bot_says) {
        if (
          (obj.type === 'tts' && !obj.text) ||
          (obj.type === 'file' && !obj.path) ||
          (obj.type === 'parameter' && (!obj.name || !obj.say_as)) ||
          (obj.type === 'url' && !obj.url)
        )
          return 'Field is required'

        if (obj.type === 'parameter' && obj.name) {
          if (!this.validateVariableFormat(obj.name))
            return 'Variable must be in ${*} format'
        }
      }
    }
    if (data.node === 'transfer') {
      if (data.property.use_integration_detail) {
        if (!data.property.integration_detail_key) {
          return `Integration detail key is required`
        }

        if (!data.property.integration_detail_value) {
          return `Integration detail value in the JSON format is required`
        }
      }

      if (data.property.use_sip_header) {
        if (!data.property.integration_detail_sip_header)
          return 'SIP header value in the JSON format is required'
      }

      if (data.property.use_append_to_number) {
        if (!data.property.integration_detail_append_to_number)
          return 'Append to number value is required'
      }

      if (data.property.type === 'flow_ui_id') {
        if (!data.property.flow_ui_id) return 'Flow is required'
      } else if (data.property.type === 'contact_id') {
        if (!data.property.contact_id) return 'Contact is required'
      } else if (data.property.type === 'number') {
        if (!data.property.number) return 'Number is required'
        if (!data.property.number_name) return 'Name is required'
      } else if (data.property.type === 'live_agent') {
        if (!data.property.queue_id) return 'Live agent is required'
      }
    }
    //  ========== use for Gen AI===========
    if (data.node === 'gen_ai') {
      if (!data.property.gen_ai) return 'Gen AI is required'
      if (!data.property.message) return 'Message is required'
    }
    //  ==========End use for Gen AI===========

    // chat
    if (data.node === 'chat_input') {
      if (
        data.property.config.is_customize_input &&
        data.property.config.setting.max_input_timeout % 5 !== 0
      )
        return 'Max Time Out is more than 5'
    }
    if (data.node === 'chat_output') {
      for (const obj of data.property.bot_says) {
        if (
          (obj.type === 'text' && !obj.text) ||
          (obj.type === 'image' &&
            ((obj.urlType === 'Internal' && !obj.path) ||
              (obj.urlType === 'External' && !obj.url))) ||
          (obj.type === 'video' && (!obj.path || !obj.previewImagePath)) ||
          (obj.type === 'quick_reply' && !obj.payload.message) ||
          (obj.type === 'button' && !obj.payload.message) ||
          (obj.type === 'parameter' && !obj.name)
        )
          return 'Field is required'

        if (obj.type === 'quick_reply' && obj.payload) {
          if (obj.payload.buttons.some(item => !item.title))
            return 'Quick reply label is required'

          if (obj.payload.buttons.some(item => !item.payload))
            return 'Quick reply message is required'
        }

        if (obj.type === 'button' && obj.payload) {
          if (obj.payload.buttons.some(item => !item.title)) {
            return 'Button title is required'
          }
          if (
            obj.payload.buttons
              .filter(item => item.type !== 'text')
              .some(item => !item.payload)
          ) {
            return 'Button payload is required'
          }
        }

        if (obj.type === 'carousel') {
          if (obj.isManual) {
            if (obj.payloads.length > 0) {
              obj.payloads = obj.payloads.map(payload => ({
                ...payload,
                preview: undefined,
                image_url: undefined
              }))
              if (obj.payloads.some(item => !item.image))
                return 'Carousel image is required'

              if (obj.payloads.some(item => !item.title))
                return 'Carousel title is required'

              if (
                obj.payloads
                  .flatMap(item => item.buttons)
                  .some(item => !item.title)
              )
                return 'Carousel button title is required'

              if (
                obj.payloads
                  .flatMap(item => item.buttons)
                  .filter(item => item.type !== 'text')
                  .some(item => !item.payload)
              )
                return 'Carousel button payload is required'
            }
          } else {
            if (!obj.variable.apiResult)
              return 'Carousel array variable is required'
            else if (!this.validateVariableFormat(obj.variable.apiResult))
              return 'Variable must be in ${*} format'

            if (!obj.variable.image)
              return 'Carousel image url variable is required'

            if (!obj.variable.title)
              return 'Carousel title variable is required'

            if (!obj.variable.subtitle)
              return 'Carousel subtitle variable is required'
          }
        }

        if (obj.type === 'parameter' && obj.name) {
          if (!this.validateVariableFormat(obj.name, 'multiple'))
            return 'Variable must be in ${*} format'
        }
      }
    }
    if (data.node === 'chat_transfer') {
      if (data.property.type === 'flow_ui_id') {
        if (!data.property.flow_ui_id) return 'Flow is required'
      } else if (data.property.type === 'live_agent') {
        if (!data.property.queue_id) return 'Live agent is required'
      }
    }
  }

  assignData(nodeData) {
    const data = JSON.parse(JSON.stringify(nodeData))

    // common
    if (data.node === 'add_retry') {
      if (data.property.type !== 'page') data.property.page = ''
      if (data.property.type !== 'component') data.property.component = ''
    }
    if (data.node === 'jump') {
      if (data.property.type !== 'component') data.property.component = ''
    }
    if (data.node === 'write') {
      let field_id = ''
      let field_name = ''
      let fields = []
      let fields_name = []
      let value = ''
      let searching_key = ''
      let lookup_table_id = ''
      let lookup_table_name = ''
      let column_index = 1
      let default_value = ''

      if (data.property.operation === 'clear') {
        fields = data.property.fields
        fields_name = data.property.fields_name
      } else if (
        ['value', 'prepend', 'append', 'increase', 'decrease'].includes(
          data.property.operation
        )
      ) {
        field_id = data.property.field_id
        field_name = data.property.field_name
        value = data.property.value
      } else if (data.property.operation === 'lookup') {
        field_id = data.property.field_id
        field_name = data.property.field_name
        value = data.property.value
        searching_key = data.property.searching_key
        lookup_table_id = data.property.lookup_table_id
        lookup_table_name = data.property.lookup_table_name
        column_index = data.property.column_index
        default_value = data.property.default_value
      }

      data.property.field_id = field_id
      data.property.field_name = field_name
      data.property.fields = fields
      data.property.fields_name = fields_name
      data.property.value = value
      data.property.searching_key = searching_key
      data.property.lookup_table_id = lookup_table_id
      data.property.lookup_table_name = lookup_table_name
      data.property.column_index = column_index
      data.property.default_value = default_value
    }

    // voice
    if (data.node === 'input') {
      if (!data.property.config.default_input.is_customize_input) {
        data.property.config.default_input.asr = {}
      }

      if (data.property.responseText) {
        try {
          data.property.response = JSON.parse(data.property.responseText)
        } catch {
          data.property.response = {}
        }
      }
    }
    if (data.node === 'prompt') {
      for (const obj of data.property.bot_says) {
        if (
          obj.type === 'parameter' &&
          ![
            'DATE_LONG_BE',
            'DATE_MEDIUM_BE',
            'DATE_SHORT',
            'DATE_CASUAL_BE'
          ].includes(obj.say_as)
        ) {
          obj.format = undefined
        }
      }
    }
    if (data.node === 'start') {
      if (data.property.default_input.beep) {
        if (!data.property.default_input.beep.enable) {
          data.property.default_input.beep.path = ''
        }
      }
    }
    if (data.node === 'transfer') {
      let flow_ui_id = ''
      let flow_ui_name = ''
      let contact_id = ''
      let contact_name = ''
      let number = ''
      let number_name = ''
      let queue_id = ''
      let queue_name = ''

      if (data.property.type === 'flow_ui_id') {
        flow_ui_id = data.property.flow_ui_id
        flow_ui_name = data.property.flow_ui_name
      } else if (data.property.type === 'contact_id') {
        contact_id = data.property.contact_id
        contact_name = data.property.contact_name
      } else if (data.property.type === 'number') {
        number = data.property.number
        number_name = data.property.number_name
      } else if (data.property.type === 'live_agent') {
        queue_id = data.property.queue_id
        queue_name = data.property.queue_name
      }

      data.property.flow_ui_id = flow_ui_id
      data.property.flow_ui_name = flow_ui_name
      data.property.contact_id = contact_id
      data.property.contact_name = contact_name
      data.property.number = number
      data.property.number_name = number_name
      data.property.queue_id = queue_id
      data.property.queue_name = queue_name
    }

    // chat
    if (data.node === 'chat_output') {
      for (const obj of data.property.bot_says) {
        if (obj.type === 'carousel') {
          if (obj.isManual) {
            obj.variable = undefined
          } else {
            obj.payloads = []
          }
        }
      }
    }
    if (data.node === 'chat_transfer') {
      let flow_ui_id = ''
      let flow_ui_name = ''
      let queue_id = ''
      let queue_name = ''
      if (data.property.type === 'flow_ui_id') {
        flow_ui_id = data.property.flow_ui_id
        flow_ui_name = data.property.flow_ui_name
      } else if (data.property.type === 'live_agent') {
        queue_id = data.property.queue_id
        queue_name = data.property.queue_name
      }

      data.property.flow_ui_id = flow_ui_id
      data.property.flow_ui_name = flow_ui_name
      data.property.queue_id = queue_id
      data.property.queue_name = queue_name
    }

    return data
  }

  replaceParametes({ rawText, replaceValue }) {
    const array = rawText.match(/\${(.*?\s*)\}/g)

    let replaceText = rawText
    if (array && array.length > 0) {
      for (const str of array) {
        replaceText = replaceText.replace(str, replaceValue)
      }
    }

    return replaceText
    // let startIndex = -1
    // let endIndex = 0
    // try {
    //   do {
    //     startIndex = rawText.indexOf('${', endIndex)
    //     if (startIndex >= 0) {
    //       endIndex = rawText.indexOf('}', startIndex)
    //       if (endIndex > startIndex) {
    //         const parameter = rawText.substring(startIndex, endIndex + 1)
    //         rawText = rawText.replace(parameter, replaceValue)
    //       } else {
    //         break
    //       }
    //     }
    //   } while (startIndex >= 0)
    // } catch {}

    // return rawText
  }
}

export default Transform

// const json = require('./202109091415-transform.json')
// const pin = new Transform(json)

// pin.transformComponent()
